// Utilidades comunes a todos los juegos: XP y contador público de partidas
import { sileo } from 'sileo';
import { useAuthStore } from '../store/authStore';
import { API_URL } from './api';


export interface XpUpdate {
  xpAwarded: number;
  totalXp: number;
  currentLevel: number;
  previousLevel: number;
  leveledUp: boolean;
  nextLevelXp: number;
  currentLevelXp: number;
}

/** Actualiza el nivel en el header y avisa si se ha subido de nivel */
export function applyXpUpdate(xp: XpUpdate | null | undefined) {
  if (!xp) return;
  const { updateLevel, triggerBadgePulse } = useAuthStore.getState();
  updateLevel(xp);
  if (xp.leveledUp) {
    triggerBadgePulse();
    sileo.success({
      title: `¡Subiste a nivel ${xp.currentLevel}!`,
      description: 'Sigue jugando para seguir subiendo',
      duration: 4000,
    });
  }
}

/** Contador público de partidas por juego (se incrementa al empezar) */
export function countGamePlay(gameId: string) {
  fetch(`${API_URL}/api/stats/plays/${gameId}`, { method: 'POST' }).catch(() => {});
}
